import React from "react";
import './PageHomeOut.css';
import "../../Atoms/Buttons/Primary/ButtonPrimary.css";
import ButtonPrimary from '../../Atoms/Buttons/Primary/ButtonPrimary';
import { Row, Col, Button, } from 'react-bootstrap';
import CardHomeOut from "../../Molecules/Cards/CardHomeOut/CardHomeOut";

const PageHomeBienvenido = () => {
    return (
        <>
            <Row className='w-100 p-0 mx-0 my-4 justify-content-center d-flex d-lg-none text-center'>
                <Col className='col-auto p-0'>
                    <Button
                        href="/inicia-sesion"
                        bsPrefix="ButtonPrimary--homeOut m-2"
                    >
                        Iniciar sesión
                    </Button>
                </Col>
                <Col className='col-auto p-0'>
                    <Button
                        href="/registro"
                        bsPrefix="ButtonSecondary--homeOut m-2"
                    >
                        Regístrate
                    </Button>
                </Col>
            </Row>
            <Row className="d-flex p-1 container__max__width">
                <Col xs={12} lg={6}>
                    <div className="textBievenido ms-md-5 mt-md-5 pt-3 supp_pading_x">
                        <p className="textBievenido__mini">Bienvenido a</p>
                        <p className="textBievenido__extra">Cuenta con tu Seguro</p>
                        <div className="textBievenido__text">
                            <p className="mb-0">
                                Accede a los nuevos servicios que <strong>Banistmo, ASSA</strong> Compañía de Seguros S.A y <strong> BNP Paribas Cardif </strong> te ofrecen por tener tus seguros activos.
                                <br />
                                <br />
                                Disfruta estos beneficios adicionales a tus coberturas y proyecta tu desarrollo personal y profesional.
                            </p>
                        </div>
                    </div>
                </Col>
                <Col xs={12} lg={6}>
                    <Row className="w-100 p-0 m-0"> 
                        <Col className="col-12 col-md-6 my-2">
                            <CardHomeOut
                                title={'Educación digital'}
                                img={'/assets/img/homeout/coursera.webp'}
                                lineColor='naranja'
                                text={'Aquí encontrarás cursos y especializaciones de las mejores universidades del mundo.'}
                            />
                        </Col>
                        <Col className="col-12 col-md-6 my-2">
                            <CardHomeOut
                                title={'Branding digital'}
                                img={'/assets/img/homeout/branding.webp'}
                                lineColor='celeste'
                                text={'Agenda una reunión especializada con un experto, para lograr que tu marca esté muy bien posicionada en medios digitales.'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default PageHomeBienvenido;
